import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PalantirProgressComponent } from '@flux/design-system';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'blank-layout',
  templateUrl: './blank.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterOutlet, PalantirProgressComponent],
})
export class BlankLayoutComponent {
  constructor(public loadingService: LoadingService) {}
}
